import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLOnboardingActionRequiredCountKeys } from "Api/Queries/Merchants/useOrbitLOnboardingActionRequiredCountQuery";
import { orbitLOnboardingDetailKeys } from "Api/Queries/Merchants/useOrbitLOnboardingDetailQuery";
import { orbitLOnboardingListKeys } from "Api/Queries/Merchants/useOrbitLOnboardingListQuery";
import {
  type ComgateTerminalTidTypeEntry,
  postMerchantsPublicIDOrbitLTidTypes,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  tids: Array<ComgateTerminalTidTypeEntry>;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useSetComgateTerminalTidTypesMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, tids }: Parameters) =>
        postMerchantsPublicIDOrbitLTidTypes({ tids }, merchantPublicID),
    ),
    onSuccess: (_data, { merchantPublicID }: Parameters) => {
      queryClient.invalidateQueries({
        queryKey: orbitLOnboardingListKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: orbitLOnboardingActionRequiredCountKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey:
          orbitLOnboardingDetailKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
